export default "__VITE_ASSET__BrwlQC2t__"